import * as React from 'react';
import { SVGProps } from 'react';

const SvgCloudPdm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <mask
      id='cloudPDM_svg__a'
      maskUnits='userSpaceOnUse'
      x={5}
      y={9}
      width={22}
      height={14}
      fill='#000'
    >
      <path fill='#fff' d='M5 9h22v14H5z' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M23.258 15.89v-.007a5.883 5.883 0 0 0-10.684-3.401 2.353 2.353 0 0 0-3.82 2.047 3.678 3.678 0 0 0 .923 7.236 3.677 3.677 0 0 0 3.275-2.004 5.869 5.869 0 0 0 4.423 2.005 5.856 5.856 0 0 0 3.403-1.084 2.941 2.941 0 1 0 2.48-4.792Z'
      />
    </mask>
    <path
      d='M23.258 15.89h-1v.935l.933.062.067-.998Zm-10.684-3.408-.628.778.828.668.616-.867-.816-.58Zm-3.82 2.047.25.968.823-.212-.077-.846-.996.09Zm4.198 5.232.751-.66-.97-1.106-.671 1.31.89.456Zm7.826.92.775-.631-.591-.725-.763.542.58.815Zm1.48-4.798v.007h2v-.007h-2ZM17.375 11a4.883 4.883 0 0 1 4.883 4.883h2A6.883 6.883 0 0 0 17.375 9v2Zm-3.985 2.06A4.876 4.876 0 0 1 17.375 11V9a6.876 6.876 0 0 0-5.616 2.903l1.63 1.158Zm-2.292-.099c.322 0 .616.112.848.3l1.256-1.557a3.343 3.343 0 0 0-2.104-.743v2Zm-1.353 1.353c0-.747.606-1.353 1.353-1.353v-2a3.353 3.353 0 0 0-3.353 3.353h2Zm.005.125a1.381 1.381 0 0 1-.005-.125h-2c0 .103.004.204.013.305l1.992-.18ZM7 18.089c0-1.245.851-2.294 2.005-2.592l-.5-1.937A4.678 4.678 0 0 0 5 18.09h2Zm2.677 2.677A2.677 2.677 0 0 1 7 18.088H5a4.677 4.677 0 0 0 4.677 4.677v-2Zm2.385-1.46a2.677 2.677 0 0 1-2.385 1.46v2a4.677 4.677 0 0 0 4.165-2.549l-1.78-.911Zm5.313 1.46a4.869 4.869 0 0 1-3.672-1.664L12.2 20.42a6.869 6.869 0 0 0 5.175 2.345v-2Zm2.824-.9a4.856 4.856 0 0 1-2.824.9v2c1.482 0 2.858-.47 3.982-1.269l-1.158-1.63Zm2.86.899a1.935 1.935 0 0 1-1.506-.715l-1.55 1.264a3.935 3.935 0 0 0 3.055 1.451v-2Zm1.94-1.941a1.941 1.941 0 0 1-1.94 1.941v2a3.941 3.941 0 0 0 3.94-3.941h-2Zm-1.808-1.937c1.01.068 1.808.91 1.808 1.937h2a3.941 3.941 0 0 0-3.674-3.932l-.134 1.995Z'
      fill='#000'
      mask='url(#cloudPDM_svg__a)'
    />
  </svg>
);

export default SvgCloudPdm;
